import { useMutation } from '@tanstack/react-query';
import axios, { AxiosError } from 'axios';

import { InsurancePaymentIntentError, InsurancePaymentIntentRequest } from '@/types/insurance';
import { API } from '@/utils/apiConstants';

const FAIL_PAYMENT_INTENT_KEY = 'failPaymentIntent';

const failPaymentIntent = async (data: InsurancePaymentIntentRequest) => {
  await axios.post(
    `${API.baseEndpoint}/api/v1/buyer_insurance/offer_on_tracking/payment_intent/fail`,
    data,
  );
};

export const useFailPaymentIntent = () => {
  return useMutation<void, AxiosError<InsurancePaymentIntentError>, InsurancePaymentIntentRequest>({
    mutationKey: [FAIL_PAYMENT_INTENT_KEY],
    mutationFn: failPaymentIntent,
  });
};
